(() => {
  if (window.cmaExternalLinksReady) return;
  window.cmaExternalLinksReady = true;
  const originals = new WeakMap();
  const normalizeHost = host => host.toLowerCase().replace(/^www\./, '');
  const localHost = normalizeHost(location.hostname);
  const attributes = ['target', 'rel', 'aria-describedby'];
  const prepare = link => {
    if (!(link instanceof HTMLAnchorElement)) return;
    let url;
    try { url = new URL(link.getAttribute('href'), document.baseURI); } catch { return; }
    const external = ['http:', 'https:'].includes(url.protocol) && normalizeHost(url.hostname) !== localHost;
    if (!external) {
      const original = originals.get(link);
      if (original) {
        attributes.forEach(name => original[name] === null ? link.removeAttribute(name) : link.setAttribute(name, original[name]));
        originals.delete(link);
      }
      return;
    }
    if (!originals.has(link)) originals.set(link, Object.fromEntries(attributes.map(name => [name, link.getAttribute(name)])));
    link.setAttribute('target', '_blank');
    const rel = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
    rel.delete('opener');
    rel.add('noopener');
    link.setAttribute('rel', [...rel].join(' '));
    if (document.getElementById('a11y-new-window-message')) {
      const describedBy = new Set((link.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
      describedBy.add('a11y-new-window-message');
      link.setAttribute('aria-describedby', [...describedBy].join(' '));
    }
  };
  const scan = root => {
    if (root instanceof HTMLAnchorElement) prepare(root);
    root.querySelectorAll?.('a[href]').forEach(prepare);
  };
  const start = () => {
    scan(document.body);
    new MutationObserver(records => records.forEach(record => {
      if (record.type === 'attributes') prepare(record.target);
      else record.addedNodes.forEach(scan);
    })).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['href']});
    ['click', 'auxclick'].forEach(type => document.addEventListener(type, event => {
      prepare(event.target.closest?.('a[href]'));
    }, true));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
